<app-banner></app-banner>

<div id="side-navigation">
    <div class="container-fluid mt-4">
        <div class="row">
            <div class="col-12 col-md-4 col-lg-3 side-menu ps-lg-5">
                <h6>Administration</h6>
                <ul class="nav flex-column">
                    <li class="nav-item" routerLinkActive="active">
                        <a class="nav-link" routerLink="/administration">Administration</a>
                    </li>
                </ul>
            </div>
            <div class="col-md-9">
                <div id="administration">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12">
                                <h4 class="card-title">Administration</h4>
                                <h4>Management</h4>
                                <p class="inner-lead">The college is run by the management of “The Sonipat Hindu Educational &
                                    Charitable Society” SONIPAT.</p>
                
                                <h4>Principal</h4>
                                <p class="inner-lead">Dr. Arun Mittal, M. Pharm, Ph.D. </p>
                
                                <!-- <h4>Faculty</h4> -->
                                <div class="row">
                                    <div class="col-12 col-md-6 col-lg-4">
                                        <div class="our-team">
                                            <div class="picture">
                                                <img class="img-fluid" src="/assets/img/faculty/1.jpg" alt="Dr. Arun Mittal">
                                            </div>
                                            <div class="team-content">
                                                <h3 class="name">Dr. Arun Mittal</h3>
                                                <h4 class="title">M. Pharm, PhD</h4>
                                            </div>
                                            <h5>Principal</h5>
                                            <ul class="social">
                                                <li><a href="https://drive.google.com/file/d/1DwmsHR1MsvI2sgnqNvX8H2SckMHqPzpO/view?usp=sharing" target="_blank">Principal</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>